export default {
  applications: {
    get: '/api/Application/get?target=desktop',
    getIcons: '/api/Application/get/icons',
    getApplication: '/api/Application/v1/get/:id?target=desktop',
    getUserSpecificApps: '/api/application/get/userspecific?target=desktop',
    getSubmittedApps: '/api/Application/submitted?target=desktop',
    getSubmittedAppById: '/api/Application/v1/submitted/:id?target=desktop',
    getContributorsByAppName: '/api/applicationcontributors/getbyappuniquename/:name',
    saveContributors: '/api/applicationcontributors/save',
    save: '/api/Application/save?target=desktop',
    getApplicationRelatedUsers:
      '/api/UserApplications/v1/get/applicationusedby/:applicationId/:userId?target=desktop',
    approveApplication: '/api/application/approve?target=desktop',
    sendToUserRevision: '/api/application/userrevision?target=desktop',
    saveDraft: '/api/application/draft/save',
    getDraft: '/api/application/draft/get/:id',
    deleteDraft: '/api/application/draft/delete/:id'
  },

  appCollections: {
    get: '/api/appcollection/get?target=desktop',
    create: '/api/appcollection/create?target=desktop',
    delete: '/api/appcollection/delete?id=:id',
    update: '/api/appcollection/update?target=desktop'
  },

  recommendation: {
    userSpecificRecommendations: '/api/recommendedapps/user',
    appSpecificRecommendations: '/api/recommendedapps/application?appUniqueName=:id'
  },

  bff: {
    getUserDetails: '/api/bff/user?target=desktop',
    getUseProfile: '/api/bff/user/profile?target=desktop',
    saveUserDetails: '/api/bff/user?target=desktop',
    getNotificationGroupMembers: '/api/bff/notification/applicationgroup/members?target=desktop',
    updateNotificationGroupMembers: '/api/bff/notification/applicationgroup/members?target=desktop',
    getADGroupsAssignedToUserByAppId: '/api/bff/user/application/adgroups',
    raiseArcRequest: '/api/bff/support/arcrequest?target=desktop',
    getAllUsers: '/api/bff/proxy/identity/api/v1/identity',
    chat: '/api/bff/generativeai/api/generative/chat',
    summarize: '/api/proxy/generativeai/api/generative/summarize',
    qna: '/api/proxy/generativeai/api/generative/qna',
    feedback: '/api/proxy/generativeai/api/generative/feedback',
    chatStream: '/api/proxy/chatstream',
    contributorAccess: '/api/bff/application/contributorarcrequest',
    smartDataSource: '/api/smartdata/getsmartdatasources',
    smartDataTopic: '/api/smartdata/getsmartdatatopics?dataSourceIdOrName=:dataSourceIdOrName',
    smartDataTopicDetail: '/api/smartdata/getsmartdatatopicdetails?topicIdOrName=:topicIdOrName',
    smartData: '/api/smartdata/formsmartdatarequest'
  },

  storage: {
    getSasToken: '/api/storage/sas-token'
  },

  smartflow: {
    run: '/api/workflow/execute',
    runById: '/api/workflow/execute/:id',
    save: '/api/workflow',
    getAll: '/api/workflow',
    delete: '/api/workflow/:id',
    smartdocs: {
      teams: '/api/proxy/smartdocs/api/team/all',
      tags: '/api/proxy/smartdocs/api/taglevel/all'
    },
    smartdata: {
      topics:
        '/api/proxy/smartdata/api%2FgetSmartDataConfiguredTopics%3FdataSourceIdOrName%3DCornerstone',
      topicCharts: '/api/proxy/smartdata/api%2FgetSmartDataTopicCharts%3FtopicIdOrName%3D{topic}'
    },
    document: {
      getById: '/api/proxy/smartdocs/api/document/{id}',
      getBlob: '/api/proxy/smartdocs/document/blob/{id}',
      getDownloadURL: '/api/proxy/smartdocs/api/document/download/{id}'
    }
  },

  applicationGroups: {
    getList: '/api/bff/application/notificationgroups?target=desktop',
    get: '/api/bff/proxy/notification/api/v1/applicationGroup%3FappGroupId%3D:appGroupId?target=desktop',
    postOnFly: '/api/bff/proxy/notification/api/applicationGroupOnFly?target=desktop',
    updateGroup: '/api/bff/proxy/notification/api/applicationGroup/update',
    deleteApplicationGroup:
      '/api/bff/proxy/notification/api/v1/deleteApplicationGroup%3FappGroupId%3D:groupId?target=desktop'
  },

  notifications: {
    sendNotification: '/api/bff/proxy/notification/api/sendNotification?target=desktop',
    updateNotification: '/api/bff/proxy/notification/api/scheduledNotification?target=desktop',
    getNotifications:
      '/api/bff/proxy/notification/api/notifications%3FuserName%3D:userName%26currentDate%3D:currentDate?target=desktop',
    getNotificationsCount:
      '/api/bff/proxy/notification/api/notificationsCount%3FuserName%3D:userName%26currentDate%3D:currentDate?target=desktop',
    putNotifications:
      '/api/bff/proxy/notification/api/notifications%3FuserName%3D:userName?target=desktop',
    getSignalRConnection: '/api/bff/proxy/notification/api/negotiate?target=desktop',
    raiseTicket: '/api/bff/support/request?target=desktop',
    getScheduledNotifications: '/api/bff/application/schedulednotifications?target=desktop',
    deleteSchedule: '/api/bff/proxy/notification/api/deleteNotifications?target=desktop',
    sendEmail: '/api/bff/notification/email?target=desktop'
  },

  userApplications: {
    createUserApplication: '/api/UserApplications/create?target=desktop',
    get: '/api/UserApplications/get/:userId/:eventType?target=desktop',
    deleteUserApplication: '/api/UserApplications/remove?target=desktop'
  },

  collections: {
    getCollectionsApps:
      '/api/ApplicationInCollections/v1/get/collection/:collectionId?target=desktop',
    createCollectionWithApps: '/api/ApplicationInCollections/save?target=desktop',
    get: '/api/ApplicationInCollections/get/:userId?target=desktop',
    getCollection: '/api/ApplicationInCollections/v1/get/collection/:id?target=desktop',
    addCollectionToWorkspace: '/api/ApplicationInCollections/use?target=desktop',
    getUserCollections: '/api/UserCollection/get/:userId?target=desktop',
    deleteSystemCollection: '/api/ApplicationInCollections/remove/collection/:id?target=desktop'
  },

  categories: {
    get: '/api/Category/get?target=desktop',
    getAppsByCategory: '/api/Application/v1/get/category/:categoryId?target=desktop',
    getRecentAppsByCategory: '/api/Application/v1/get/recent/category/:categoryId?target=desktop',
    getCategory: '/api/Category/v1/get/:categoryId?target=desktop',
    getAppCategories: '/api/Category/get/all?target=desktop'
  },

  identity: {
    getUserDetails: '/v1/identity?target=identity'
  },

  jobs: {
    get: '/api/JobFunction/get?target=desktop'
  },

  multiSelect: {
    get: '/api/MultiSelect/get?target=desktop'
  },

  picture: {
    uploadIcon: '/api/Picture/upload/icon?target=desktop',
    uploadScreenshot: '/api/Picture/upload/screenshot?target=desktop',
    getIcon: '/api/Picture/get/icons?target=desktop',
    getScreenshots: '/api/Picture/get/screenshots?target=desktop'
  },

  search: {
    get: '/api/Application/get/search',
    /** Query string appended to `search.get` to fetch the "new arrivals" catalogue. */
    newArrivalsQuery: '?search=newArrivals&badge=2'
  },

  tags: {
    get: '/api/Tag/get?target=desktop'
  },

  userCollections: {
    get: '/api/UserCollection/get/:userId?target=desktop',
    create: '/api/UserCollection/create?target=desktop',
    delete: '/api/UserCollection/remove?target=desktop'
  },

  userFiles: {
    post: '/api/user/files/upload?target=desktop'
  },

  userInterests: {
    get: '/api/user/interests?target=desktop'
  },

  userGroups: {
    get: '/api/userGroups?target=desktop',
    getGroupById: '/api/userGroupsByAppGroupId?appGroupId=:appGroupId?target=desktop'
  },

  userGuide: {
    docUpload: '/api/userguide/upload/document',
    urlUpload: '/api/userguide/upload/url?url=:url'
  },

  userOnboarding: {
    fund: '/api/fund?target=desktop',
    benchmark: '/api/benchmark?target=desktop',
    issuer: '/api/issuer?target=desktop'
  },

  reviews: {
    getByApp: '/api/Review/v1/get/application/:applicationId?target=desktop',
    addReview: '/api/Review/create?target=desktop'
  },

  widgetsExternal: {
    singleLine: 'https://as-mg-dev1-t1-ios-dal-01.api-apps-inv-dev.mandg.co.uk/SingleLineChart',
    multiLine: 'https://as-mg-dev1-t1-ios-dal-01.api-apps-inv-dev.mandg.co.uk/MultiLineChart',
    radarChart: 'https://as-mg-dev1-t1-ios-dal-01.api-apps-inv-dev.mandg.co.uk/RadarChart',
    pieChart: 'https://as-mg-dev1-t1-ios-dal-01.api-apps-inv-dev.mandg.co.uk/PieChart',
    news: 'https://as-mg-dev1-t1-ios-dal-01.api-apps-inv-dev.mandg.co.uk/News',
    statistics: 'https://as-mg-dev1-t1-ios-dal-01.api-apps-inv-dev.mandg.co.uk/Statistics'
  },

  workspace: {
    create: '/api/workspaces',
    getWorkspaces: '/api/workspaces',
    getTemplates: '/api/workspaces/templates',
    getById: '/api/workspaces/:id',
    update: '/api/workspaces/:id',
    delete: '/api/workspaces/:id',
    disablePopupModal:
      '/api/userapplications/workspacepopupdisable?isWorkspacePopupDisable=:isDisabled&userSid=:sid',
    getWorkspaceConfig: '/api/customconfig/:key',
    saveWorkspaceConfig: '/api/customconfig'
  },

  customAssistant: {
    create: '/api/assistantsettings/save',
    get: '/api/assistantsettings/getall',
    getById: '/api/assistantsettings/get/:assistantId',
    delete: '/api/assistantsettings/delete/:assistantId'
  },

  chatHistory: {
    newChat: '/api/bff/proxy/chathistory/api/chats/new',
    getAllChats: '/api/bff/proxy/chathistory/api/chats/:sourceId/allchats',
    getChatById: '/api/bff/proxy/chathistory/api/chats/:chatId',
    updateTitle: '/api/bff/proxy/chathistory/api/chats/:chatId/updatetitle'
  },

  nexus: {
    chatStream: '/api/agent/chat-stream-agui',
    regenerateResponse: '/api/message/regenerate-response-agui',
    getConversationList: '/api/thread/list',
    searchThreads: '/api/thread/search',
    generateConversationTitle: '/api/thread/:id/generateName',
    updateConversation: '/api/thread/:id',
    getThreadDetails: '/api/thread/:id',
    getChatMessages: '/api/thread/:id/messages',
    editPrompt: '/api/message/:id',
    uploadResource: '/api/resource/upload',
    sendFeedback: '/api/feedback',
    getDataboxes: (skipCount = 0, maxResultCount = 100) =>
      `/api/databox?skipCount=${skipCount}&maxResultCount=${maxResultCount}`,
    getDataboxDocuments: (databoxId: string | number) => `/api/databox/${databoxId}/documents`,
    getDataboxDataProduct: (databoxId: string | number) => `/api/databox/${databoxId}/data-products`
  },

  agents: {
    getAllAssistants: '/api/agent/list',
    getMyAgents: '/api/agents/listbyuser',
    getEnterpriseAgents: '/api/agents/listByUser?agentType=Enterprise',
    getTeamAgents: '/api/agent/listbyuser?agentType=Team&teamScopeId=:teamId',
    getAgentById: '/api/agent/:id',
    createAgent: '/api/agent',
    updateAgent: '/api/agent/:id',
    deleteAgent: '/api/agent/:id',
    getModels: '/api/model/list',
    generatePrompt: '/api/agent/adhoc-chat',
    deleteMemory: '/api/memory/:id',
    pinMemory: '/api/memory/:id/pin',
    getMemories: '/api/memories',
    getSkills: '/api/skills',
    getSkillCategories: '/api/skills/categories',
    downloadSkillPackage: (skillId: string) => `/api/skills/${skillId}/package/download`
  },

  marketplaceAgents: {
    getPublishedAgents: '/api/marketplaceagent/published',
    getDraftAgents: '/api/marketplaceagent/drafts',
    getPublishedSkills: '/api/marketplaceskill/published',
    getDraftSkills: '/api/marketplaceskill/drafts',
    getPublishedAgentByName: (uniqueName: string) => `/api/marketplaceagent/${uniqueName}`,
    getAgentDetails: (uniqueName: string) => `/api/marketplaceagent/${uniqueName}`,
    getPublishedSkillByName: (uniqueName: string) => `/api/marketplaceskill/${uniqueName}`,
    getSkillDetails: (uniqueName: string) => `/api/marketplaceskill/${uniqueName}`,
    upsertMarketplaceAgent: '/api/marketplaceagent/upsert',
    upsertMarketplaceSkill: '/api/marketplaceskill/upsert',
    uploadSkillPackage: '/api/marketplaceskill/package/upload',
    downloadSkillPackage: (uniqueName: string) => `/api/marketplaceskill/${uniqueName}/package`,
    publishMarketplaceAgent: (uniqueName: string) => `/api/marketplaceagent/${uniqueName}/publish`,
    unpublishMarketplaceAgent: (uniqueName: string) =>
      `/api/marketplaceagent/${uniqueName}/unpublish`,
    deleteMarketplaceAgent: (uniqueName: string) => `/api/marketplaceagent/${uniqueName}`,
    publishMarketplaceSkill: (uniqueName: string) => `/api/marketplaceskill/${uniqueName}/publish`,
    unpublishMarketplaceSkill: (uniqueName: string) =>
      `/api/marketplaceskill/${uniqueName}/unpublish`,
    deleteMarketplaceSkill: (uniqueName: string) => `/api/marketplaceskill/${uniqueName}`,
    getMarketplaceRatings: (uniqueName: string, page = 1, pageSize = 20) =>
      `/api/marketplacerating/${uniqueName}?page=${page}&pageSize=${pageSize}`,
    submitMarketplaceRating: (uniqueName: string) => `/api/marketplacerating/${uniqueName}`,
    agentArcRequest: '/api/bff/support/agentarcrequest'
  },

  mcpServer: {
    getAll: '/api/mcpserver/list'
  },

  marketplaceMedia: {
    upload: '/api/marketplacemedia/upload',
    delete: (id: number) => `/api/marketplacemedia/${id}`
  },

  marketplaceDomains: {
    getAll: (activeOnly = true) => `/api/marketplacedomain?activeOnly=${activeOnly}`,
    create: '/api/marketplacedomain',
    update: (domainId: string) => `/api/marketplacedomain/${domainId}`,
    delete: (domainId: string) => `/api/marketplacedomain/${domainId}`
  },

  dataMarketplace: {
    proxy: '/api/proxy/investmentdatahub:url',
    getDatasets: '/api/discovery/dataProduct/list?isDiscoverable=true',
    search: '/api/dataProduct/semanticSearch',
    getDataProduct: '/api/discovery/assets/:id',
    dataPreview: '/api/proxy/investmentdatahub/api/dataproducts/data/preview',
    perviewPreview: '/api/proxy/cornerstone/api/DataProduct/GetDataPreview/:tableName?top=10',
    downloadDataset: '/api/proxy/investmentdatahub/api/dataproducts/data/download/schedule',
    getDates:
      '/api/proxy/investmentdatahub/api/dataproducts/availabledates?DataProductName=:dataProductName',
    getFilters:
      '/api/proxy/investmentdatahub/api/dataproducts/recommendedfilters?DataProductName=:dataProductName',
    userADGroups: '/api/bff/user/adgroups',
    dataProduct: '/api/discovery/dataProduct/:id',
    getAllDatabox: '/api/databox?skipCount=0&maxResultCount=100',
    addDataProduct: '/api/databox/:databox/data-products',
    dataProductArcRequest: '/api/bff/support/dataproductarcrequest',
    getDataProductArcStatus: '/api/bff/user/dataproduct/adgroups'
  },

  dataMarketplaceAdmin: {
    list: '/api/dataProduct/list',
    dataProduct: '/api/dataProduct/:id',
    syncAIReadySchema: '/api/dataproduct/:id/sync-ai-ready-schema',
    generateEmbedding: '/api/dataProduct/GenerateSingleDataProductEmbedding',
    addVerifiedQuery: '/api/verifiedquery/:dataProductId',
    verifiedQuery: '/api/verifiedquery/:id',
    getAISchema: '/api/discovery/AISchema?id=:id',
    updateSchema: '/api/dataProduct/:id/aiReadySchema',
    semanticView: '/api/dataProduct/semanticViews'
  },

  users: {
    getAllUsers: '/api/users?skipCount=0&maxResultCount=100'
  },

  featureGates: {
    list: '/api/admin/feature-gates',
    create: '/api/admin/feature-gates',
    update: '/api/admin/feature-gates/:id',
    delete: '/api/admin/feature-gates/:id',
    gateUsers: '/api/admin/feature-gates/:id/users',
    setUserAccess: '/api/admin/feature-gates/:id/users/:email',
    removeUserAccess: '/api/admin/feature-gates/:id/users/:email',
    gateGroups: '/api/admin/feature-gates/:id/groups',
    groups: '/api/admin/feature-gate-groups',
    createGroup: '/api/admin/feature-gate-groups',
    deleteGroup: '/api/admin/feature-gate-groups/:id',
    groupMembers: '/api/admin/feature-gate-groups/:id/members',
    addGroupMembers: '/api/admin/feature-gate-groups/:id/members/bulk',
    addGroupMember: '/api/admin/feature-gate-groups/:id/members/:email',
    removeGroupMember: '/api/admin/feature-gate-groups/:id/members/:email',
    setGroupAccess: '/api/admin/feature-gates/:id/groups/:groupId',
    removeGroupAccess: '/api/admin/feature-gates/:id/groups/:groupId',
    getFeatureValue: '/api/features/:key'
  },

  microapps: {
    registry: (target = 'desktop') => `/api/microapps/registry?target=${target}`,
    apps: (target = 'desktop') => `/api/appd/v2/apps?target=${target}`,
    appById: (appId: string) => `/api/appd/v2/apps/${encodeURIComponent(appId)}`
  },

  banners: {
    deliveryForPage: (placement: string, includeDraft = false) =>
      `/api/content-blocks?placement=${placement}&includeDraft=${includeDraft}`,
    allForPage: (placement: string, skipCount = 0, maxResultCount = 100, reorderCohort = true) =>
      `/api/admin/content-blocks?skipCount=${skipCount}&maxResultCount=${maxResultCount}&reorderCohort=${reorderCohort}&placement=${placement}`,
    getById: (id: number | string) => `/api/admin/content-blocks/${id}`,
    uploadImages: '/api/admin/content-blocks/images',
    create: '/api/admin/content-blocks',
    update: (id: number | string) => `/api/admin/content-blocks/${id}`,
    reorder: '/api/admin/content-blocks/reorder',
    archive: (id: number | string) => `/api/admin/content-blocks/${id}/archive`,
    delete: (id: number | string) => `/api/admin/content-blocks/${id}`
  },

  arcRoles: {
    list: '/api/arcrole',
    create: '/api/arcrole',
    update: '/api/arcrole/:id',
    delete: '/api/arcrole/:id',
    getById: '/api/arcrole/:id',
    getByExternalId: '/api/arcrole/by-external-id/:externalId'
  },

  mcpServers: {
    list: '/api/mcpserver/list',
    create: '/api/mcpserver',
    update: '/api/mcpserver/:id',
    delete: '/api/mcpserver/:id',
    getById: '/api/mcpserver/:id',
    arcRoles: {
      list: '/api/mcpserver/:id/arcroles',
      assign: '/api/mcpserver/:id/arcroles',
      unassign: '/api/mcpserver/:id/arcroles/:portalArcRoleExternalId'
    }
  },

  teams: {
    getAllTeams: '/api/teams',
    getTeamById: (teamId: string) => `/api/teams/${teamId}`,
    getTeamDetailsById: (teamId: string) => `/api/teams/${teamId}/details`,
    getTeamMembersById: (teamId: string, skipCount = 0, maxResultCount = 100) =>
      `/api/teams/${teamId}/members?skipCount=${skipCount}&maxResultCount=${maxResultCount}`,
    addTeamMembers: '/api/teams/:teamId/members',
    updateTeamMemberRole: (teamId: string, memberId: string | number) =>
      `/api/teams/${teamId}/members/${memberId}`,
    removeTeamMember: (teamId: string, memberId: string | number) =>
      `/api/teams/${teamId}/members/${memberId}`,
    createTeam: '/api/teams',
    updateTeam: '/api/teams',
    deleteTeam: '/api/teams',
    getUsersList: '/api/users?skipCount=0&maxResultCount=100',
    getTeamDataboxes: (teamId: string, skipCount = 0, maxResultCount = 100) =>
      `/api/teams/${teamId}/databoxes?skipCount=${skipCount}&maxResultCount=${maxResultCount}`,
    getTeamApps: (teamId: string, skipCount = 0, maxResultCount = 100) =>
      `/api/teams/${teamId}/applications?skipCount=${skipCount}&maxResultCount=${maxResultCount}`,
    addApp: (teamId: string) => `/api/teams/${teamId}/applications`,
    removeApp: (teamId: string, appId: string) => `/api/teams/${teamId}/applications/${appId}`,
    getRecentItems: (teamId: string) => `/api/teams/${teamId}/recent-items`
  },

  databox: {
    getDataProducts: (
      skipCount = 0,
      maxResultCount = 100,
      isDiscoverable = true,
      isAccessStatusRequired = true
    ) =>
      `/api/data-products?skipCount=${skipCount}&maxResultCount=${maxResultCount}&isDiscoverable=${isDiscoverable}&IsAccessStatusRequired=${isAccessStatusRequired}`,
    getDataProduct: (id: string, isAccessStatusRequired = true) =>
      `/api/data-products/${id}?IsAccessStatusRequired=${isAccessStatusRequired}`,
    addDataProductsToDatabox: (databoxId: string) => `/api/databox/${databoxId}/data-products`,
    addDataProductsToDataboxBulk: (databoxId: string) =>
      `/api/databox/${databoxId}/data-products/bulk`,
    bulkRemoveDataProductsFromDatabox: (databoxId: string) =>
      `/api/databox/${databoxId}/data-products/bulk-remove`,
    bulkRemoveFilesFromDatabox: (databoxId: string) => `/api/databox/documents/bulk`,
    bulkRemoveResourcesFromPersonalDatabox: (personalDataboxId: string) =>
      `/api/databox/personal/${personalDataboxId}/resources/bulk-remove`,
    bulkDownloadPersonalDocuments: '/api/databox/personal/documents/bulk-download',
    reprocessDocuments: `/api/document/reprocess`,
    getDataboxDataProducts: (databoxId: string) => `/api/databox/${databoxId}/data-products`,
    getDataboxDetails: (databoxId: string, isSmartDocsId: boolean = false) =>
      `/api/databox/${databoxId}/details${isSmartDocsId ? '?isSmartDocsId=true' : ''}`,
    getRecentItems: (teamId: string) => `/api/teams/${teamId}/recent-items`,
    createDatabox: '/api/databox',
    getDataboxInfo: (databoxId: string, isSmartDocsId: boolean = false) =>
      `/api/databox/${databoxId}${isSmartDocsId ? '?source=SmartDocs' : ''}`,
    deleteDatabox: (databoxId: string) => `/api/databox/${databoxId}`,
    databoxDocuments: (databoxId: string) => `/api/databox/${databoxId}/documents`,
    getDocumentCategory: '/api/document-category/smartdocs/all',
    getDocumentIssuer: '/api/document-issuer/smartdocs/all',
    getDocumentTags: (teamId: string) => `/api/tags/smartdocs/${teamId}/all`,
    downloadDocument: (documentId: string) => `/api/databox/documents/download/${documentId}`,
    bulkExtract: (documentId: string) => `/api/document/bulk-extraction/${documentId}`,
    getDocumentDetails: '/api/document/GetDocumentsByCognitiveSearchIds',
    removeDataProductFromDatabox: (databoxId: string, dataProductId: string) =>
      `/api/databox/${databoxId}/data-products/${dataProductId}`,
    removeDocumentFromDatabox: (databoxId: string, documentId: string) =>
      `/api/databox/${databoxId}/documents/${documentId}`
  },

  userfiles: {
    download: '/api/userfiles/download?blobName=:blobName'
  },

  projects: {
    getAll: '/api/project/list',
    getById: '/api/project/:id',
    create: '/api/project',
    update: '/api/project/:id',
    delete: '/api/project/:id',
    getThreads: '/api/project/:id/threads',
    moveThread: '/api/project/:id/threads/:threadId',
    removeThread: '/api/project/:id/threads/:threadId',
    addFile: '/api/project/:id/files/:resourceId',
    getFiles: '/api/project/:id/files',
    deleteFile: '/api/project/:id/files/:resourceId',
    personalDataBoxes: '/api/project/:id/personal-data-boxes'
  }
}
